import * as runtime from '@/api/runtime'
import {
  BatchExpiredUserListRequest,
  BatchExpiredUserListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchExpiredUserListCondition,
  BatchExpiredUserListConditionFromJSON
} from '@/api/models/batch/BatchExpiredUserListCondition'

/**
 * 帳票作成
 */
export class BatchExpiredUserListApi extends runtime.BaseAPI {
  async return(request: BatchExpiredUserListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/user-management/expired-user-list`,
      BatchExpiredUserListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchExpiredUserListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchExpiredUserListConditionFromJSON(jsonValue)
    ).value()
  }
}
